import React from 'react'
import {ArrowRight, MapPin} from 'lucide-react'

export default function Hero() {
  const backgroundImage = 'https://static.lumi.new/material/8b/8b57585f0f9f7e22a22d9ed5452c60e6.png'

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-40 sm:pt-32 pb-16 sm:pb-20 px-4">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-black/20 to-black/40" />
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-500/30 rounded-full blur-3xl animate-pulse" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-red-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }} />
      </div>

      <div className="relative max-w-7xl mx-auto text-center w-full mt-24 sm:mt-32">
        <div className="inline-flex items-center gap-2 bg-blue-600/20 backdrop-blur-sm border border-blue-400/30 px-4 sm:px-6 py-2.5 sm:py-3 rounded-full mb-6 sm:mb-8 animate-in fade-in slide-in-from-bottom-4 duration-700 max-w-full">
          <MapPin className="text-blue-400 flex-shrink-0" size={18} />
          <span className="text-white font-medium text-xs sm:text-sm md:text-base text-center leading-snug">
            Plan de Campagne - 554 Rte de Calas, Les Pennes Mirabeau, 13170
          </span>
        </div>

        <h1 className="text-3xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6 sm:mb-8 leading-tight animate-in fade-in slide-in-from-bottom-6 duration-700 px-4" style={{ animationDelay: '0.1s', fontFamily: 'Syne, sans-serif' }}>
          <span className="text-white block mb-2">Votre mandataire</span>
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-white to-red-500 block">automobile premium</span>
        </h1>
        
        <p className="text-base sm:text-lg md:text-xl lg:text-2xl text-white/90 mb-8 sm:mb-12 max-w-3xl mx-auto leading-relaxed animate-in fade-in slide-in-from-bottom-8 duration-700 font-light px-4" style={{ animationDelay: '0.2s', fontFamily: 'Outfit, sans-serif' }}>
          Achat, vente et import de véhicules neufs et d'occasion à Plan de Campagne
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 animate-in fade-in slide-in-from-bottom-10 duration-700 px-4" style={{ animationDelay: '0.3s' }}>
          <a 
            href="#vehicules" 
            className="group bg-gradient-to-r from-blue-600 to-blue-500 text-white px-8 sm:px-10 py-3.5 sm:py-4 rounded-full font-bold text-sm sm:text-base md:text-lg hover:from-blue-500 hover:to-blue-400 transition-all shadow-2xl shadow-blue-500/30 hover:shadow-blue-500/50 hover:scale-105 flex items-center gap-3 w-full sm:w-auto justify-center"
          >
            Découvrir nos véhicules
            <ArrowRight className="group-hover:translate-x-1 transition-transform flex-shrink-0" size={20} />
          </a>
          <a 
            href="#contact" 
            className="group bg-white/10 backdrop-blur-sm border-2 border-white/30 text-white px-8 sm:px-10 py-3.5 sm:py-4 rounded-full font-bold text-sm sm:text-base md:text-lg hover:bg-white/20 transition-all hover:scale-105 flex items-center gap-3 w-full sm:w-auto justify-center"
          >
            Nous contacter
            <ArrowRight className="group-hover:translate-x-1 transition-transform flex-shrink-0" size={20} />
          </a>
        </div>

        <div className="mt-12 sm:mt-16 grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 md:gap-8 max-w-4xl mx-auto animate-in fade-in slide-in-from-bottom-12 duration-700" style={{ animationDelay: '0.4s' }}>
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:bg-white/10 transition-all hover:scale-105">
            <div className="text-3xl sm:text-4xl font-black text-blue-400 mb-2" style={{ fontFamily: 'Syne, sans-serif' }}>+500</div>
            <div className="text-white/70 font-medium text-sm sm:text-base">Véhicules vendus</div>
          </div>
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:bg-white/10 transition-all hover:scale-105">
            <div className="text-3xl sm:text-4xl font-black text-white mb-2" style={{ fontFamily: 'Syne, sans-serif' }}>100%</div>
            <div className="text-white/70 font-medium text-sm sm:text-base">Clients satisfaits</div>
          </div>
          <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-xl sm:rounded-2xl p-5 sm:p-6 hover:bg-white/10 transition-all hover:scale-105">
            <div className="text-3xl sm:text-4xl font-black text-red-500 mb-2" style={{ fontFamily: 'Syne, sans-serif' }}>3 ans</div>
            <div className="text-white/70 font-medium text-sm sm:text-base">D'expertise</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black to-transparent" />
    </section>
  )
}
